import Button from "@components/button/button";
import { buttonTheme } from "@components/button/button-constants";
import TopicflowIcon from "@components/topicflow-icon/topicflow-icon";

const ViewOptionsButton = ({
  highlighted,
  disabled,
  onClick,
}: {
  highlighted: boolean;
  disabled?: boolean;
  onClick: () => void;
}) => {
  return (
    <div className="relative">
      <Button
        disabled={disabled}
        className="flex items-center"
        theme={buttonTheme.iconGray}
        onClick={onClick}
        aria-label="View Options"
      >
        <TopicflowIcon type="adjustments" className="h-4 w-4" />
      </Button>
      {highlighted && (
        <span className="absolute -top-1 -left-1 flex h-3 w-3">
          <span className="relative inline-flex h-3 w-3 rounded-full bg-amber-400"></span>
        </span>
      )}
    </div>
  );
};

export default ViewOptionsButton;
